import { palette } from './palettle';
import { typography } from './typography';

export const foundations = { palette, typography }